import { useCallback } from 'react';

/**
 * Hook for haptic feedback - uses Web Vibration API when available
 * Falls back to no-op on unsupported browsers
 */
export const useHaptics = () => {
  const canVibrate = typeof navigator !== 'undefined' && 'vibrate' in navigator;

  const lightImpact = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate(10);
    }
  }, [canVibrate]);

  const mediumImpact = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate(20);
    }
  }, [canVibrate]);

  const heavyImpact = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate(30);
    }
  }, [canVibrate]);

  const successNotification = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate([10, 50, 10]);
    }
  }, [canVibrate]);

  const errorNotification = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate([30, 50, 30]);
    }
  }, [canVibrate]);

  const warningNotification = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate([20, 30, 20]);
    }
  }, [canVibrate]);

  const selectionChanged = useCallback(async () => {
    if (canVibrate) {
      navigator.vibrate(5);
    }
  }, [canVibrate]);

  return {
    lightImpact,
    mediumImpact,
    heavyImpact,
    successNotification,
    errorNotification,
    warningNotification,
    selectionChanged,
    isNative: false
  };
};
